export const WHAT_TO_BRING = [
  "Documento",
  "Água",
  "Protetor solar",
  "Celular/câmera",
  "Roupas e calçados confortáveis",
];

export const STOPS = {
  "Mirante Dona Marta": {
    image: "donaMartaSunrise",
    description:
      "A 360 metros de altura, no Parque Nacional da Tijuca, o mirante entrega uma vista panorâmica do Cristo, do Pão de Açúcar, da Baía de Guanabara e da Zona Sul. É a parada ideal para as primeiras fotos do dia, com a cidade inteira aos seus pés.",
  },
  "Cristo Redentor": {
    image: "cristo",
    description:
      "Uma das Sete Maravilhas do Mundo Moderno, no alto do Corcovado. Subimos de van oficial e eu oriento os melhores ângulos e o momento certo para aproveitar a vista sem correria, com a história do monumento contada no caminho.",
  },
  "Pão de Açúcar": {
    image: "paoDeAcucar",
    description:
      "O bondinho em dois trechos — Morro da Urca e Pão de Açúcar — revela a Baía de Guanabara, Copacabana, Botafogo e o Cristo ao longe. Costumo programar a visita para o fim do dia, quando a luz fica dourada e a cidade começa a acender.",
  },
  "Escadaria Selarón": {
    image: "selaron",
    description:
      "Entre Lapa e Santa Teresa, os 215 degraus cobertos por azulejos de mais de 60 países são a obra de uma vida do artista chileno Jorge Selarón. Uma parada colorida e cheia de histórias, que eu conto durante a visita.",
  },
  "Mirante dos Prazeres": {
    image: "arcosLapa",
    description:
      "Em Santa Teresa, um mirante tranquilo e pouco conhecido pelos turistas, com vista para o Centro, a Baía de Guanabara e os Arcos da Lapa. O bairro boêmio, de ruas de paralelepípedo e casarões, é um charme à parte.",
  },
};

export const TOURS = [
  {
    slug: "essencial-cristo-dona-marta",
    name: "Essencial: Cristo e Dona Marta",
    stops: ["Mirante Dona Marta", "Cristo Redentor"],
    duration: "3 a 5 horas",
    price: "269",
    min: "538",
    minNote: "2 pessoas",
    description:
      "Para quem tem pouco tempo e não quer ficar sem o principal. Começamos no Mirante Dona Marta, com a cidade e a baía aos seus pés, e seguimos para o Cristo Redentor, sem correria e com as orientações de quem conhece o melhor momento para cada parada.",
    included: [
      "Guia credenciado",
      "Transfer de ida e volta da hospedagem",
      "Café da manhã (cortesia)",
      "Ingresso do Cristo Redentor (subida de van)",
    ],
    notIncluded: ["Demais refeições e bebidas", "Gastos pessoais"],
    image: "cristo",
    gallery: ["donaMartaSunrise", "hero", "cristo", "donaMartaSunset"],
  },
  {
    slug: "rio-classico-santa-teresa",
    name: "Rio Clássico e Santa Teresa",
    stops: ["Cristo Redentor", "Mirante Dona Marta", "Mirante dos Prazeres", "Escadaria Selarón"],
    duration: "6 a 8 horas",
    price: "289",
    min: "578",
    minNote: "2 pessoas",
    description:
      "Um roteiro que mistura natureza, vistas e cultura. Além do Cristo e do Dona Marta, você conhece o Mirante dos Prazeres, em Santa Teresa, e termina na Escadaria Selarón, com seus azulejos coloridos vindos de vários países e uma história que eu conto durante a visita.",
    included: [
      "Guia credenciado",
      "Transfer de ida e volta da hospedagem",
      "Café da manhã (cortesia)",
      "Ingresso do Cristo Redentor (subida de van)",
    ],
    notIncluded: ["Demais refeições e bebidas", "Gastos pessoais"],
    image: "selaron",
    gallery: ["cristo", "donaMartaSunrise", "arcosLapa", "selaron", "hero"],
  },
  {
    slug: "cartoes-postais",
    name: "Os Cartões-Postais",
    stops: ["Cristo Redentor", "Mirante Dona Marta", "Pão de Açúcar"],
    duration: "6 a 8 horas",
    price: "539",
    min: "1078",
    minNote: "2 pessoas",
    description:
      "Os dois maiores símbolos do Rio em um só dia, com uma parada de vista no meio do caminho. Organizo os horários para aproveitar melhor cada atração e evitar perder tempo em fila sempre que possível.",
    included: [
      "Guia credenciado",
      "Transfer de ida e volta da hospedagem",
      "Café da manhã (cortesia)",
      "Ingressos do Cristo Redentor (subida de van) e do Pão de Açúcar (bondinho)",
    ],
    notIncluded: ["Demais refeições e bebidas", "Gastos pessoais"],
    image: "paoDeAcucar",
    gallery: ["hero", "paoDeAcucar", "praiaVermelha", "donaMartaSunset", "cristo"],
  },
  {
    slug: "rio-completo",
    name: "Rio Completo",
    stops: ["Mirante Dona Marta", "Cristo Redentor", "Pão de Açúcar", "Escadaria Selarón"],
    duration: "6 a 8 horas",
    price: "589",
    min: "1178",
    minNote: "2 pessoas",
    description:
      "O roteiro mais completo: as grandes vistas, os cartões-postais e a arte colorida da Escadaria Selarón. Ideal para quem tem um dia inteiro e quer conhecer o Rio com tranquilidade.",
    included: [
      "Guia credenciado",
      "Transfer de ida e volta da hospedagem",
      "Café da manhã (cortesia)",
      "Ingressos do Cristo Redentor (subida de van) e do Pão de Açúcar (bondinho)",
    ],
    notIncluded: ["Demais refeições e bebidas", "Gastos pessoais"],
    image: "praiaVermelha",
    gallery: ["donaMartaSunrise", "cristo", "paoDeAcucar", "praiaVermelha", "selaron", "hero"],
  },
];

export const formatBRL = (value) => parseInt(value, 10).toLocaleString("pt-BR");
